import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function FaqHashRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    const redirectFaqHash = () => {
      if (window.location.hash === "#faq") {
        navigate("/faq", { replace: true });
      }
    };
    window.addEventListener("hashchange", redirectFaqHash);
    redirectFaqHash();
    return () => window.removeEventListener("hashchange", redirectFaqHash);
  }, [navigate]);
  return null;
}